import { afterUpdateProfileHook } from '../../../../models/profile/hooks/after-update'
import { PROFILE_CLASS_NAME } from '../../../../models/profile/constants'

import { deleteInstanceFromDomainListsReduxUtil } from '../../utils/delete-instance-from-domain-lists'
import getClassNameReduxUtil from '../../utils/get-class-name'
import getDomainListPathsReduxUtil from '../../utils/get-domain-list-path'
import { isEqualContentArrayUtil } from '../../../../utils/array/is-equal-content'
import addInstanceToDomainListReduxUtil from '../../utils/add-instance-to-domain-list'

const CLASS_NAME_TO_FUNCTION = {
  [PROFILE_CLASS_NAME]: afterUpdateProfileHook
}

function afterUpdateReduxHook (instance, state, existingInstance) {
  const className = getClassNameReduxUtil(instance)
  if (!className) {
    return state
  }

  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (fn) {
    state = fn(instance, state, existingInstance)
  }

  if (isEqualContentArrayUtil(
    getDomainListPathsReduxUtil(existingInstance),
    getDomainListPathsReduxUtil(instance)
  )) {
    return state
  }

  if (existingInstance) {
    state = deleteInstanceFromDomainListsReduxUtil({
      state,
      instance: existingInstance
    })
  }

  return addInstanceToDomainListReduxUtil({
    state,
    instance
  })
}

export default afterUpdateReduxHook
